import { useRef } from 'react';
import { useAppSelector } from '@store';
import {
  ButtonPrimary,
  ButtonPseudo,
  PermissionDenied,
  PermissionEnum,
  Popup,
  SidePanel,
  SidePanelType,
} from '@ui/src';
import useCreateForm from './hooks/use-create-form';
import CreateForm from '../../../components/individual/create/create';
import { ApplicationSchemeType } from '../../new-application/types';

import cn from './styles.module.css';
import commonStyles from '../../common/common.module.css';

const CreateOrganizationForm = () => {
  const sidepanelRef = useRef<HTMLDivElement | null>(null);

  const { applicationSchemes, deliveryChannelsIndividual } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { activePermissions, countriesList: countries } = useAppSelector(
    (state) => state.root,
  );

  const {
    dirtyPopupVisible,
    setDirtyPopupVisible,
    errorMessage,
    sumSubError,
    setSelectedApplicationScheme,
    isLoading,
    control,
    errors,
    isDirty,
    handleClose,
    onSubmit,
    panelIsOpen,
  } = useCreateForm({
    sidepanelRef,
  });

  let content;

  if (
    !activePermissions?.includes(
      PermissionEnum.INDIVIDUAL_CUSTOMERS_CREATE_ACTION,
    )
  ) {
    content = <PermissionDenied />;
  } else {
    content = (
      <CreateForm
        control={control}
        errors={errors}
        sumSubError={sumSubError}
        applicationSchemes={applicationSchemes?.filter(
          (item) => item.type === ApplicationSchemeType.INDIVIDUAL,
        )}
        activePermissions={activePermissions}
        setSelectedSchema={setSelectedApplicationScheme}
        deliveryChannelsIndividual={deliveryChannelsIndividual}
        countries={countries}
      />
    );
  }

  return (
    <>
      <SidePanel
        type={SidePanelType.Customers}
        closeOnClickOutside
        isOpen={panelIsOpen}
        onClose={isDirty ? () => setDirtyPopupVisible(true) : handleClose}
        title="Create Individual customer"
        childrenRef={sidepanelRef}
        footer={
          <div className={cn.sidePanelFooterWrapper}>
            {activePermissions?.includes(
              PermissionEnum.INDIVIDUAL_CUSTOMERS_CREATE_ACTION,
            ) && (
              <ButtonPrimary
                text={isLoading ? 'Loading...' : 'Create application'}
                onClick={onSubmit}
                disabled={!isDirty || isLoading}
                bold
              />
            )}

            <ButtonPseudo
              text={
                !activePermissions?.includes(
                  PermissionEnum.INDIVIDUAL_CUSTOMERS_CREATE_ACTION,
                )
                  ? 'Close'
                  : 'Cancel'
              }
              onClick={handleClose}
              bold
            />
            {Object.keys(errors)?.length > 0 && (
              <div className={commonStyles.createFormError}>
                There are errors in some fields
              </div>
            )}
          </div>
        }
        errorSidepanel={errorMessage}
        sidepanelExpandedKey="create-individual"
      >
        {content}
      </SidePanel>
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={handleClose}
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
        parent={document.getElementById('dirty-popup') as HTMLElement}
      />
      <div id="dirty-popup" />
    </>
  );
};

export default CreateOrganizationForm;
